/**
 * File banner-carousel.js
 *
 * Handles Swiper Carousels for the homepage banner.
 */

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-unresolved */
import Swiper, { Pagination, Autoplay, Keyboard } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';

document.addEventListener( 'DOMContentLoaded', function () {
	if (
		document.querySelectorAll( '.banner-carousel' ).length &&
		document.querySelectorAll( '.banner-carousel .swiper-slide' ).length > 1
	) {
		new Swiper( '.banner-carousel', {
			modules: [ Pagination, Autoplay, Keyboard ],
			cssMode: true,
			pagination: {
				el: '.banner-pagination',
				clickable: true,
				horizontalClass: 'magnatiles-pagination',
				renderBullet( index, className ) {
					const slideColor = this.slides[ index ].dataset.color;
					return (
						'<span class="' +
						className +
						' magnatiles-pager pager-' +
						slideColor +
						'"></span>'
					);
				},
			},
			speed: 500,
			loop: true,
			keyboard: true,
			autoplay: {
				delay: 7000,
				pauseOnMouseEnter: true,
			},
			// preventClicks: false,
		} );
	}
} );
